angular.module('appSettingOrderTutorial', [
  'ngRoute',
  'ngResource',
  'ngFileUpload',
  'core',
  'core.auth',
  'core.env',
  'pascalprecht.translate',
]);



// WEBPACK FOOTER //
// ./src/app/app-setting/order-tutorial/order-tutorial.module.js